import { ApiPublicInstance } from "@/services/api/api.public";
import ApiInstance from "@/services/api/api.utils";
import { formatDate } from "@/services/utils/formatter";
import { get } from "lodash";

export const getJobInformationList = async (params) => {
  const res = await ApiInstance.get("/jobs", { params });
  // const formatAddressRes = {
  //   docs: res.docs?.map((item) => {
  //     return {
  //       ...item,
  //       address: `${get(item, `city.name[${i18n.language}]`)}, ${get(
  //         item,
  //         `district.name[${i18n.language}]`
  //       )}`,
  //     };
  //   }),
  // };
  // return formatAddressRes;
  return res;
};

export const getJobDetail = async (id) => {
  const res = await ApiInstance.get(`/jobs/${id}`);
  return {
    ...res,
    // startPeriod: formatDate(get(res, "startPeriod")),
    monthSalary: `${get(res, "monthSalaryMin")} ~ ${get(
      res,
      "monthSalaryMax"
    )}`,
    corporate: {
      ...res.corporate,
      dateOfEstablishment: formatDate(
        get(res, "corporate.dateOfEstablishment")
      ),
    },
  };
};

export const getJobDetailPublic = async (id) => {
  const res = await ApiPublicInstance.get(`/jobs/${id}`);
  return {
    ...res,
    startPeriod: formatDate(get(res, "startPeriod")),
    monthSalary: `${get(res, "monthSalaryMin", "")} ~ ${get(
      res,
      "monthSalaryMax",
      ""
    )}`,
    corporate: {
      ...res.corporate,
      dateOfEstablishment: formatDate(
        get(res, "corporate.dateOfEstablishment")
      ),
    },
    address: `${get(res, "postcodeAddress")} ${get(res, "detailAddress", "")}`,
  };
};

export const getCorporateRecruitmentListPublic = async (id) => {
  const res = await ApiPublicInstance.get(`/jobs`, {
    params: { corporate: id },
  });
  return res;
};

export const getRecruitmentWithUser = async (params) => {
  const res = await ApiInstance.get("jobs/interview", {
    params,
  });
  return res;
};
